import { render, staticRenderFns } from "./TheSimonGame.component.vue?vue&type=template&id=35b1aaa0&scoped=true&"
import script from "./TheSimonGame.component.vue?vue&type=script&lang=js&"
export * from "./TheSimonGame.component.vue?vue&type=script&lang=js&"
import style0 from "./TheSimonGame.component.vue?vue&type=style&index=0&id=35b1aaa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1aaa0",
  null
  
)

export default component.exports